import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreTypeForm from '../../../components/forms/ScoreTypeForm';
import { useCreateScoreType } from '../../../hooks/useScoreTypeApi';
import { useNavigate } from 'react-router-dom';
import { ScoreTypeDTO } from '../../../services/apiClient';

const ScoreTypeCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateScoreType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Score Types', href: '/admin/scoretypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ScoreTypeDTO) => {
    try {
      setIsSubmitting(true);
      await createMutation.mutateAsync(data);
      navigate('/admin/scoretypes');
    } catch (error) {
      console.error('Error creating ScoreType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scoretypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ScoreType.Edit"
    >
      <ScoreTypeForm
        initialValues={{} as ScoreTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/scoretypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ScoreTypeCreate;
